module.exports = __webpack_public_path__ + "img/panorama.835c533d.png";